import { createSelector } from 'reselect';

export const getBuildings = createSelector(
  (state) => state.clients.data.buildings,
  (buildings) => {
    return buildings;
  }
);

export const getClients = createSelector(
  (state) => state.clients.data.clients,
  (clients) => {
    return clients;
  }
);

export const getCurrentClient = createSelector(
  (state) => state.clients.data.currentClient,
  (currentClient) => {
    return currentClient;
  }
);

export const getCurrentFilter = createSelector(
  (state) => state.clients.ui.currentFilter,
  (currentFilter) => {
    return currentFilter;
  }
);

export const getCurrentPage = createSelector(
  (state) => state.clients.ui.currentPage,
  (currentPage) => {
    return currentPage;
  }
);

export const getForm = createSelector(
  (state) => state.clients.ui.form,
  (form) => {
    return form;
  }
);

export const getInvalidFields = createSelector(
  (state) => state.clients.ui.invalidFields,
  (invalidFields) => {
    return invalidFields;
  }
);

export const getInvoices = createSelector(
  (state) => state.clients.data.invoices,
  (invoices) => {
    return invoices;
  }
);

export const getPurchaseOrders = createSelector(
  (state) => state.clients.data.purchaseOrders,
  (purchaseOrders) => {
    return purchaseOrders;
  }
);

export const getRoles = createSelector(
  (state) => state.clients.data.roles,
  (roles) => {
    return roles;
  }
);

export const getValidationMessage = createSelector(
  (state) => state.clients.ui.validationMessage,
  (validationMessage) => {
    return validationMessage;
  }
);

export const getShowContactsModal = createSelector(
  (state) => state.clients.ui.showContacts,
  (showContacts) => {
    return showContacts;
  }
);

export const getShowInviteClientModal = createSelector(
  (state) => state.clients.ui.showInviteClientModal,
  (showInviteClientModal) => {
    return showInviteClientModal;
  }
);

export const getShowInviteClientUserModal = createSelector(
  (state) => state.clients.ui.showInviteClientUserModal,
  (showInviteClientUserModal) => {
    return showInviteClientUserModal;
  }
);

export const getSurveys = createSelector(
  (state) => state.clients.data.surveys,
  (surveys) => {
    return surveys;
  }
);

export const getUsers = createSelector(
  (state) => state.clients.data.users,
  (users) => {
    return users;
  }
);

export const getWorkOrders = createSelector(
  (state) => state.clients.data.workOrders,
  (workOrders) => {
    return workOrders;
  }
);

export const getProjects = createSelector(
  (state) => state.clients.data.projects,
  (projects) => {
    return projects;
  }
);

export const noteEditorSelector = createSelector(
  (state) => state.clients.ui.noteEditor,
  (noteEditor) => {
    return noteEditor;
  }
);

export const getClientsCurrentPage = createSelector(
  (state) => state.clients.ui.clientsCurrentPage,
  (clientsCurrentPage) => {
    return clientsCurrentPage;
  }
);

export const getClientsTotal = createSelector(
  (state) => state.clients.ui.clientsTotal,
  (clientsTotal) => {
    return clientsTotal;
  }
);

export const getClientsPageSize = createSelector(
  (state) => state.clients.ui.clientsPageSize,
  (clientsPageSize) => {
    return clientsPageSize;
  }
);



// WEBPACK FOOTER //
// ./src/selectors/admin/clients/clients.js